import { TFunction } from "i18next";

import { Button, Text } from "@pentabd/ui";

import { ProfileInfoCard } from "@components";

import { EmployeeType } from "@type/HRM/employees";
import { InitiateTransferType } from "@type/HRM/transfer-candidates";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  handleInitiateTransfer: (ids: InitiateTransferType) => void,
) => {
  return [
    {
      id: 1,
      key: "nameBn",
      name: t("TRANSFER_CANDIDATES.TABLE.COLUMN.NAME"),
      render: (__: string, row: EmployeeType) => (
        <ProfileInfoCard employee={row as any} />
      ),
    },
    {
      id: 2,
      key: "employeeCode",
      name: t("TRANSFER_CANDIDATES.TABLE.COLUMN.EMPLOYEE_ID"),
      render: (employeeCode: string) => (
        <Text color="info" className="text-nowrap">
          {employeeCode}
        </Text>
      ),
    },
    {
      id: 3,
      key: "workingPlace",
      name: t("TRANSFER_CANDIDATES.TABLE.COLUMN.PRESENT_OFFICE"),
      render: (workingPlace: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {workingPlace}
        </Text>
      ),
    },
    {
      id: 4,
      key: "joiningDate",
      name: t("TRANSFER_CANDIDATES.TABLE.COLUMN.JOINING_DATE"),
      render: (joiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {joiningDate}
        </Text>
      ),
    },
    {
      id: 5,
      key: "lastPromotionDate",
      name: t("TRANSFER_CANDIDATES.TABLE.COLUMN.LAST_PROMOTION_DATE"),
      render: (lastPromotionDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {lastPromotionDate ? lastPromotionDate : "N/A"}
        </Text>
      ),
    },
    {
      id: 6,
      key: "id",
      name: "",
      render: (id: number) => {
        const handleInitiate = () => {
          handleInitiateTransfer([id] as any);
        };
        return (
          <div className="d-flex justify-content-end align-items-center">
            <Button
              size="sm"
              fill="outline"
              onClick={handleInitiate}
              type="light"
            >
              {t("TRANSFER_CANDIDATES.TABLE.COLUMN.BUTTON_TEXT")}
            </Button>
          </div>
        );
      },
    },
  ];
};
